<template>
<el-dialog :visible="visible" :title="title" @open="onOpened" @close="onClose" @closed="onClosed" top="2vh" width="800px" v-loading="loading">

    <div class="d-flex align-items-start">
        <div class="symbol symbol-40 symbol-light-success mr-3">
            <el-image class="border rounded" style="width: 200px; height: 200px" :src="person.photo" :fit="'fill'"></el-image>
        </div>
        <div class="content w-100">
            <div class="col-sm-12 mb-4">
                <label class="mb-0">Documento</label>
                <div class="form-control form-control-sm">{{person.docName + ' - ' + person.docnumber}}</div>
            </div>
            <div class="col-sm-12 mb-4">
                <label class="mb-0">Nombres y apellidos</label>
                <div class="form-control form-control-sm">{{person.firstname + ' ' + person.lastname + ' ' + person.surname}}</div>
            </div>
            <div class="row px-4">
                <div class="col-sm-6">
                    <label class="mb-0">Fecha de nacimiento</label>
                    <div class="form-control form-control-sm">{{$moment(person.birthday).format("DD/MM/YYYY")}}</div>
                </div>
                <div class="col-sm-6">
                    <label class="mb-0">Edad</label>
                    <div class="form-control form-control-sm">{{person.age}}</div>
                </div>
            </div>
        </div>
    </div>
    <el-tabs v-model="activeTab" @tab-click="tabClick">
        <el-tab-pane label="Registrar" name="one">

            <el-form :model="blackForm" ref="blackForm">
                <div class="row mb-4">
                    <label class="col-sm-4">No. Poom/Dan</label>
                    <div class="col-sm-8">
                        <el-form-item prop="nro_poomdan" class="mb-0"
                            :rules="[
                                { required: true, message: 'Este campo es requerido', trigger: ['blur', 'change'] }
                            ]">
                            <el-input v-model="blackForm.nro_poomdan" class="w-auto" size="small" maxlength="10"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="row mb-4">
                    <label class="col-sm-4">Poom/Dan</label>
                    <div class="col-sm-8">
                        <el-form-item prop="poomdan" class="mb-0"
                            :rules="[
                                { required: true, message: 'Este campo es requerido', trigger: ['blur', 'change'] }
                            ]">
                            <el-select v-model="blackForm.poomdan" size="small" placeholder="-- Seleccione --">
                                <el-option v-for="(item, index) in danes" :key="index" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        
                    </div>
                </div>

                <div class="row mb-4">
                    <label class="col-sm-4">Fecha de emisión</label>
                    <div class="col-sm-8">
                        <el-form-item prop="date_issuance" class="mb-0"
                            :rules="[
                                { type: 'date', required: true, message: 'Este campo es requerido', trigger: ['blur', 'change'] }
                            ]">
                            <el-date-picker v-model="blackForm.date_issuance" type="date" size="small" class="w-auto" placeholder="Seleccione"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>

            </el-form>

            <div class="row">
                <div class="col-sm-4">
                    Archivo: <br>{{filename}}
                </div>
                <div class="col-sm-8">
                    <el-upload class="upload-demo" 
                    ref="upload"
                    :headers="headers" name="file" 
                    :action="`${endPointUpload}api/file/poomdan`" accept=".jpg,.png,.pdf" 
                    :auto-upload="false"
                    :data="{id: this.person.idpayroll, nro_poomdan: this.blackForm.nro_poomdan, poomdan: this.blackForm.poomdan, date_issuance: $moment(this.blackForm.date_issuance).format('YYYY-MM-DD'), file: 'file'}" 
                    :show-file-list="true" 
                    :before-upload="fileBeforeUpload" 
                    :on-change="handleChange"
                    :on-remove="handleRemove"
                    :on-success="fileHandleSuccess" 
                    :on-error="fileHandleError"
                    :limit="1">
                        <el-button slot="trigger" size="small" type="success" plain>Selecciona un archivo</el-button>
                        <div slot="tip" class="el-upload__tip">Solo archivos jpg/png/pdf con un tamaño menor de 1MB</div>
                    </el-upload>
                </div>
                
            </div>
        </el-tab-pane>
        <el-tab-pane label="Historial" name="two">
            <el-table v-loading="loading_poomdan" :data="pagedTableData" highlight-current-row height="280" :border="false">
                <el-table-column prop="nro_poomdan" label="No. Poom/Dan" width="120"></el-table-column>
                <el-table-column prop="poomdan" label="Poom/Dan" width="100"></el-table-column>
                <el-table-column prop="date_issuance" label="Emitido" width="100"></el-table-column>
                <el-table-column prop="created_at" label="Registrado"></el-table-column>
                <el-table-column label="Estado" width="100">
                    <template #default="scope">
                        <span class="badge badge-light-success" v-if="scope.row.mstatus == 1">Aprobado</span>
                        <span class="badge badge-light-danger" v-if="scope.row.mstatus == 2">Anulado</span>
                        <span class="badge badge-light-primary" v-if="scope.row.mstatus == 3">Pendiente</span>
                    </template>
                </el-table-column>
                <el-table-column label="Opciones" width="100">
                    <template #default="scope">
                        <el-dropdown>
                                <span class="el-dropdown-link">
                                    Opciones<i class="el-icon-setting el-icon--right"></i>
                                </span>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item >
                                            <a :href="`${endPointUpload}writable/uploads/${scope.row.file}`" target="_blank">
                                            <i class="fas fa-cloud-upload-alt"></i>ver archivo</a>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>

        </el-tab-pane>
    </el-tabs>

    <template #footer class="border border-top">
        <el-button v-if="activeTab==='one'" type="primary" size="small" @click="submitUpload('blackForm')">Guardar</el-button>
        <el-button size="small" @click="onClose">Cancelar</el-button>
    </template>

</el-dialog>
</template>

<script>
import {
    mapGetters
} from "vuex";

//services
import JwtService from "@/core/services/jwt.service";
import personService from "@/core/services/person.service";

export default {
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
        title: {
            type: String,
            required: true,
            default: "",
        },
        person: {
            type: Object,
            required: true,
            default: {}
        }
    },
    data: () => ({
        activeTab: 'one',
        list: [],
        page: 1,
        pageSize: 5,
        currentPage: 1,
        blackForm: {
            nro_poomdan: null,
            poomdan: null,
            date_issuance: null
        },
        headers: {
            Authorization: `Bearer ${JwtService.getToken()}`
        },
        endPointUpload: null,
        loading: false,
        filename: null,
        fileList: 0,
        loading_poomdan: true
    }),
    computed: {
        ...mapGetters(['danes']),
        pagedTableData: function () {
            return this.list.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)
        }
    },
    methods: {
        onOpened() {
            this.activeTab = 'one'
        },
        onClose() {
            this.$emit("update:visible", false);
        },
        onClosed() {
            this.$emit("loadBlackBelts");
        },
        setPage(val) {
            this.page = val
        },
        fileBeforeUpload(file) {
            const isIMAGE = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'application/pdf');
            if (!isIMAGE) {
                this.$message.error('Formato de archivo no válido!');
                return false;
            }
            
            this.loading = true
            return true;
        },
        fileHandleSuccess(res, file) {
            this.loading = false
            this.filename = null
            this.fileList = 0
            this.$refs["blackForm"].resetFields()
            this.$alert(res.message, 'Hayllis', {type: 'success', callback: action => {
                this.activeTab = 'two'
                this.tabClick()
            }})
        },
        fileHandleError(err, file) {
            this.filename = null
            this.loading = false
            const e = JSON.parse(err.message);
            this.$alert(e.messages.error, 'Error ' + e.error, {
                type: 'warning'
            });
        },
        handleChange(file, fileList) {
            this.filename = file.name
            this.fileList = fileList.length
            if(this.fileList==0)
                this.filename = null    
        },
        handleRemove(){
            this.filename = null
        },
        submitUpload(formName){
            this.$refs[formName].validate((valid) => {
                if (!valid) 
                    return false

                if(this.filename == null)
                    return this.$message.error('Falta seleccionar el archivo a subir');

                this.$confirm(`Desea registrar a ${this.person.firstname} y adjuntar el archivo ${this.filename}. Continuar?`, 'Confirmación', {
                    confirmButtonText: 'SI',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$refs.upload.submit();
                })
            })
        },
        async loadHistoryPoomDan(){
            this.loading_poomdan = true
            await personService.PoomDan(this.person).then((res) => {
                console.log(res.data)
                this.list = res.data
            }).catch((err) => {
                this.loading_poomdan = false
            }).finally(() => {
                this.loading_poomdan = false
            })
        },
        tabClick(tab, event){
            if(this.activeTab == 'two')
                this.loadHistoryPoomDan()
        }
    },
    created(){
        this.endPointUpload = process.env.VUE_APP_URL_BACKEND
    }

}
</script>
